import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'You don’t have any cards',
  description: 'There are no cards associated to this account.',
})
